import { linkOptions } from '@tanstack/react-router'

import { featureEnabled } from '@/lib/feature-flag'
import { useOrg } from '@/selectors/organization'
import { useSearchParamsStore } from '@/store/searchParams/searchParams'

const onDemandPayFeatureEnabled = featureEnabled('VITE_DIRECT_EWA_ENABLED')

export const useNavLinks = () => {
  const getSearchParams = useSearchParamsStore(state => state.getSearchParams)

  const {
    data: { directEwaEnabled },
  } = useOrg()

  const navLinkOptions = linkOptions([
    {
      to: '/account',
      activeOptions: { exact: true, includeSearch: false },
      label: 'Payouts',
      search: getSearchParams({
        from: '/_authenticated/account/_dashboard/',
      }),
    },
    {
      to: '/account/onDemandPay',
      activeOptions: { includeSearch: false },
      label: 'On-Demand Pay',
      search: getSearchParams({
        from: '/_authenticated/account/_dashboard/onDemandPay/',
      }),
    },
  ])

  return onDemandPayFeatureEnabled && directEwaEnabled ? navLinkOptions : []
}
